import { adminInstance } from "@/api/instance";

export default async function (data) {
  return adminInstance.post("/review", data);
}
